<template>
    <div class="MessageQueueDetail">
        <div class="MessageQueueDetail-title">
            <Breadcrumb>
                <BreadcrumbItem>{{this.$route.query.accountTypeName}}</BreadcrumbItem>
                <BreadcrumbItem>{{this.$route.query.accountName}}</BreadcrumbItem>
                <BreadcrumbItem>{{this.$route.query.name}}</BreadcrumbItem>
                <BreadcrumbItem to="/monitor/messageQueueMonitor">{{ $t('alarms.queue.queue') }}</BreadcrumbItem>
            </Breadcrumb>
        </div>
        <Row type="flex" justify="space-between" class="code-row-bg">
            <Col span="6">
                <Card style="height: 480px;">
                    <Row>
                        <Row style="height: 240px;">
                            <Col span="24" style="text-align: center;font-size: 103px;display: block;margin-top: 8px;">
                                <Icon type="ios-repeat" />
                            </Col>
                            <Col style="text-align: center;font-size:18px;">{{this.$route.query.name}}</Col>
                        </Row>
                        
                        <Row style="margin-bottom: 20px;">
                            <Col>{{ $t('alarms.queue.queueDescription') }}</Col>
                            <Col>---</Col>
                        </Row>
                        <Row>
                            <Col style="margin-bottom: 8px;">{{ $t('alarms.queue.queueConfiguration') }}</Col>
                            <Row>
                                <Col span="12">{{ $t('alarms.queue.agentName') }}:</Col>
                                <Col span="10">{{brokerName}}</Col>
                            </Row>
                            <Row>
                                <Col span="12">{{ $t('alarms.queue.agentInstanceType') }}:</Col>
                                <Col span="10">{{hostInstanceType}}</Col>
                            </Row>
                            <Row>
                                <Col span="12">{{ $t('alarms.queue.agentEngine') }}:</Col>
                                <Col span="10">{{engineType}}</Col>
                            </Row>
                        </Row>
                    </Row>
                </Card>
            </Col>
            <Col span="13">
                <Card style="height: 480px;">
                    <ul class="content">
                        <li>
                            <Row>
                                <Col span="12">
                                    <Col span="4">
                                        <Button shape="circle" icon="ios-laptop"></Button>
                                    </Col>
                                    <Col span="20">
                                        <Row>
                                            <Col>{{ $t('alarms.queue.configurationInformation') }}</Col>
                                            <Row class="host">
                                                <Col>
                                                    <ul>
                                                        <li>{{ $t('alarms.queue.configurationName') }}：</li>
                                                        <li>{{configName}}</li>
                                                    </ul>
                                                </Col>                                                
                                            </Row>
                                        </Row>
                                    </Col>
                                </Col>
                                <Col span="12">
                                    <Col span="4">
                                        <Button shape="circle" icon="ios-pulse"></Button>
                                    </Col>
                                    <Col span="20">
                                        <Row>
                                            <Col>{{ $t('alarms.common.monitorMessage') }}</Col>
                                            <Row class="host">
                                                <Col>
                                                    <ul>
                                                        <li>{{ $t('alarms.common.monitorItems') }}：</li>
                                                        <li>{{monitoringNum}}{{ $t('alarms.common.count') }}</li>
                                                    </ul>
                                                </Col>
                                                 <Col>
                                                    <a @click="monitorMQ">{{ $t('alarms.common.viewMonitoringOverview') }}</a>
                                                </Col>
                                            </Row>
                                        </Row>
                                    </Col>
                                </Col>
                            </Row>
                        </li>
                    </ul>
                </Card>
            </Col>
             <Col span="4">
                <Card style="height: 480px;">
                    <Row>
                        <Row style="margin-bottom: 10px;">
                            <Col>{{ $t('alarms.common.tags') }}</Col>
                        </Row>
                        <Row>
                            <Col v-for="(item,index) in tagList" v-bind:key="index">
                                <Tag color="default">{{item.key}} : {{item.value}}</Tag>
                            </Col>
                        </Row>
                    </Row>
                </Card>
            </Col>
        </Row>
    </div>
</template>

<script>
    import utils from '../../../utils/utils.js'
    export default {
        name: 'MessageQueueDetail',
        data(){
            return {
                id:'',
                accountId:'',
                brokerId:'',
                broker:'',
                region:'',
                brokerName:'',
                hostInstanceType:'',
                engineType:'',
                monitoringNum:'',
                configName:'',
                accountTypeName:'',
                accountName:'',
                tagList:[]
            }
        },
        mounted () {
            this.queryBrokerSummaryById();
        },
        methods: {
            // 通过brokerId查询实例
            queryBrokerSummaryById:function(){
                this.$api.brokerSummary.queryBrokerSummaryById({
                    "accountId": this.$route.query.accountId,
                    "brokerId": this.$route.query.brokerId,
                    "region": this.$route.query.region
                })
                .then(res => {
                    this.brokerName=res.data.brokerName;
                    this.hostInstanceType=res.data.hostInstanceType;
                    this.engineType=res.data.engineType;
                    this.monitoringNum=res.data.monitoringNum;
                    this.configName=res.data.configName;
                    this.tagList=res.data.mapTag;
                    this.broker=res.data.broker;
                });
            },
            // 点击查看监控概览
            monitorMQ: function(){
                this.id = this.$route.query.id;
                this.accountId=this.$route.query.accountId;
                this.brokerId=this.$route.query.brokerId;
                this.region=this.$route.query.region;
                this.accountTypeName=this.$route.query.accountTypeName;
                this.accountName=this.$route.query.accountName;
                this.name=this.$route.query.name;
                this.$router.push({path:'/monitor/messageQueue/',query: {id: this.id,accountId:this.accountId,brokerId:this.brokerId,region:this.region,broker:this.broker,accountTypeName:this.accountTypeName,accountName:this.accountName,name:this.name}});
            }
        }
        
    }
</script>

<style scoped>
    .MessageQueueDetail-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 15px 4px;
        font-weight: 600;
    }
    .ivu-breadcrumb {
        font-size: 13px;
        font-weight: 600;
        color: #515a6e;
    }
    .host ul
    {
        list-style: none;
        overflow: hidden;
    }
    .host ul li
    {
        float: left;
    }
    .content>li
    {
        margin-bottom: 6px;
        border-bottom: 1px dashed #ccc;
        padding: 12px;
    }
    .content>li:last-child
    {
        border:none;
    }

</style>



// WEBPACK FOOTER //
// src/components/monitor/mq/MessageQueueDetail.vue